import { responsiveMediaFragment } from '~/gql/mediaFragments.gql'
import { localeFragment, linkBlock } from './fragments.gql'

export default `query cartQuery($locale: SiteLocale) {
  cart(${localeFragment}) {
  emptyItems {
    id
    ${responsiveMediaFragment('image')}
    title
    subtitle
    link {
      ${linkBlock}
    }
  }
  }
}`
